import { FormFieldVariants } from "./types";

export const IMAGE_ACCEPT =
  "image/jpg,image/jpeg,image/gif,image/png,image/x-eps";
export const MEDIA_ACCEPT = ".pdf, .mp4, .ppt, .pptx";
export const DOC_FILE_ACCEPT = ".pdf, .doc, .docx, .xls, .xlsx";

export const FORM_FIELD_STYLE_VARIANTS = {
  [FormFieldVariants.PRIMARY]: "font-semibold",
};

export const TEXT_INPUT_STYLE_VARIANTS = {
  [FormFieldVariants.PRIMARY]:
    "border border-black-base/20 px-5 py-3 rounded-3xl bg-inherit",
};

export const LABEL_STYLE_VARIANTS = {
  [FormFieldVariants.PRIMARY]: "",
};
